import React, { useRef, isValidElement } from "react";
import classes from "./Transition.scss";
import { Transition as ReactTransition } from "react-transition-group";

// https://reactcommunity.org/react-transition-group/transition

const Transition = props => {
  const {
    children,
    isOpen = false,
    timeout = 300,
    defaultStyle = {},
    transitionStyles = {},
    unmountOnExit = false,
    mountOnEnter = false,
  } = props;

  const nodeRef = useRef(null);

  if (!isValidElement(children)) return null;

  return (
    <ReactTransition
      nodeRef={nodeRef}
      in={isOpen}
      timeout={timeout}
      unmountOnExit={unmountOnExit}
      mountOnEnter={mountOnEnter}
    >
      {state => {
        return (
          <div
            ref={nodeRef}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            className={classes.container}
          >
            {children}
          </div>
        );
      }}
    </ReactTransition>
  );
};

export default Transition;
